import React from 'react'
import ReactDOM from 'react-dom'
import { config } from 'config'
import App from 'app/App'
import 'styles/index.css'
import reportWebVitals from 'reportWebVitals'

const { DOMAIN_URL } = config!

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

/* istanbul ignore next */
if (!!DOMAIN_URL && !window.location.origin.includes('localhost') && window.location.origin !== DOMAIN_URL) {
  window.location.replace(DOMAIN_URL)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
